var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.557 5.53c1.618 0 2.652-1.099 2.652-2.457C5.178 1.648 4.175.58 2.589.58S-.032 1.648 0 3.073C-.031 4.43 1.003 5.53 2.557 5.53M.131 7.472v15.82h4.917V7.472zm8.727.001c.065 1.391.13 3.074.13 5.047h.002v10.775h4.918V14.17c0-.454.064-.907.194-1.23.323-.906 1.13-1.844 2.49-1.844 1.78 0 2.49 1.39 2.49 3.43v8.768H24V13.91c0-4.657-2.427-6.792-5.661-6.792-2.621 0-4.238 1.52-4.885 2.523h-.098l-.227-2.168z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin;